import { createContext, useContext, useSyncExternalStore, type ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { AuthState, AuthStore } from './authStore';

const Ctx = createContext<AuthStore | null>(null);

export function AuthProvider({ store, children }: { store: AuthStore; children: ReactNode }) {
  return <Ctx.Provider value={store}>{children}</Ctx.Provider>;
}

export function useAuthStore(): AuthStore {
  const s = useContext(Ctx);
  if (!s) throw new Error('useAuthStore phải nằm trong <AuthProvider>');
  return s;
}

export function useAuth(): AuthState & Pick<AuthStore, 'login' | 'logout'> {
  const store = useAuthStore();
  const state = useSyncExternalStore(store.subscribe, store.getState, store.getState);
  return { ...state, login: store.login, logout: store.logout };
}

/** Chặn route riêng tư. Hết phiên ⇒ về /login kèm lý do và đường dẫn cũ. */
export function RequireAuth({ loginPath = '/login', fallback }: { loginPath?: string; fallback: ReactNode }) {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'booting') return <>{fallback}</>;
  if (status === 'authenticated') return <Outlet />;
  const params = new URLSearchParams();
  if (status === 'expired') params.set('reason', 'expired');
  params.set('from', loc.pathname + loc.search);
  return <Navigate to={`${loginPath}?${params.toString()}`} replace />;
}
